<template>
  <nav :style="{ background: backgroundColor }">
    <router-link
      :to="{ name: 'Home' }"
      class="logo"
      :style="{ color: textColor }"
      >DOLAS</router-link
    >
    <ul class="list">
      <li class="item-link">
        <router-link :to="{ name: 'Tshirts' }" :style="{ color: textColor }"
          >T-Shirts</router-link
        >
      </li>
      <li class="item-link">
        <router-link :to="{ name: 'Hoodies' }" :style="{ color: textColor }"
          >Hodies</router-link
        >
      </li>
      <li class="item-link">
        <router-link :to="{ name: 'Pants' }" :style="{ color: textColor }"
          >Pants</router-link
        >
      </li>
      <li class="item-link">
        <router-link :to="{ name: 'Sweatshirts' }" :style="{ color: textColor }"
          >Sweatshirts</router-link
        >
      </li>
      <li class="item-link">
        <router-link :to="{ name: 'Coats' }" :style="{ color: textColor }"
          >Coats</router-link
        >
      </li>
    </ul>
    <div class="icons-list">
      <router-link :to="{ name: 'Registration' }">
        <button class="profile-btn" :style="{ filter: iconsColor }"></button>
      </router-link>
      <router-link :to="wishlistRoute"
        ><button class="liked-btn" :style="{ filter: iconsColor }"></button
      ></router-link>
      <router-link :to="cartRoute"
        ><button class="cart-btn" :style="{ filter: iconsColor }"></button
      ></router-link>
    </div>
    <div class="burger">
      <button class="burger-btn">
        <img src="/images/burger.svg" @click="toggleMenu" alt="" />
      </button>
    </div>
    <div class="mobile-nav" :class="{ show: isOpen }">
      <img src="/images/cross.svg" @click="closeMenu" class="close" alt="" />
      <ul>
        <li class="mobile-link">
          <router-link :to="{ name: 'Tshirts' }">T-Shirts</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="{ name: 'Hoodies' }">Hodies</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="{ name: 'Pants' }">Pants</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="{ name: 'Sweatshirts' }">Sweatshirts</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="{ name: 'Registration' }">Profile</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="wishlistRoute">Wishlist</router-link>
        </li>
        <li class="mobile-link">
          <router-link :to="cartRoute">Cart</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      backgroundColor: "#fff",
      textColor: "#000",
      iconsColor: "invert(0)",
      isOpen: false,
    };
  },
  watch: {
    $route(to) {
      if (to.path === "/") {
        this.backgroundColor = "rgba(0, 0, 0, 0.28)";
        this.textColor = "#fff";
        this.iconsColor = "invert(0)";
      } else {
        this.backgroundColor = "#DBDBDB";
        this.textColor = "#000";
        this.iconsColor = "invert(0%) sepia(0%) saturate(0%) brightness(0%)";
      }
    },
  },
  computed: {
    userId() {
      return this.$store.getters.userData
        ? this.$store.getters.userData.id
        : "guest";
    },
    cartRoute() {
      return `/Cart/${this.userId}`;
    },
    wishlistRoute() {
      return `/Wishlist/${this.userId}`;
    },
  },
  mounted() {
    this.updateStyles();
  },
  methods: {
    updateStyles() {
      if (!this.$route) return;
      if (this.$route.path === "/") {
        this.backgroundColor = "rgba(0, 0, 0, 0.28)";
        this.textColor = "#fff";
        this.iconsColor = "invert(0)";
      } else {
        this.backgroundColor = "#DBDBDB";
        this.textColor = "#000";
        this.iconsColor = "invert(0%) sepia(0%) saturate(0%) brightness(0%)";
      }
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 60px;
  background: rgba(0, 0, 0, 0.28);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.28);
}

.logo {
  color: #fff;
  font-family: "Glusp";
  font-size: 2.6rem;
  margin-right: 80px;
}

.list {
  display: flex;
  gap: 75px;
}

.item-link {
  list-style-type: none;
}

.item-link a {
  text-decoration: none;
  color: #fff;
  font-size: 2rem;
  font-family: "Mabry Pro";
  font-weight: 500;
}

.icons-list {
  display: flex;
  gap: 30px;
}

.profile-btn,
.liked-btn,
.cart-btn {
  background-size: cover;
  background-repeat: no-repeat;
  background: transparent;
}

.profile-btn {
  width: 34px;
  height: 34px;
  background-image: url("/public/images/profile.svg");
}

.liked-btn {
  width: 37px;
  height: 37px;
  background-image: url("/public/images/favorite.svg");
}

.cart-btn {
  width: 33px;
  height: 33px;
  background-image: url("/public/images/cart.svg");
}

.burger {
  display: none;
}

.burger-btn {
  background: none;
  outline: none;
}

/* Mobile menu (sidebar style) */
.mobile-nav {
  position: fixed;
  top: 0;
  right: -100%;
  width: 250px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  padding: 10px 20px;
  z-index: 1000;
}

.mobile-link a {
  text-decoration: none;
  color: #000;
  font-size: 2rem;
  font-family: "Mabry Pro";
  font-weight: 500;
}

.mobile-nav.show {
  left: 0;
}

.mobile-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav li {
  margin: 20px 0;
}

.mobile-nav a {
  color: #000;
  text-decoration: none;
  font-size: 1.5rem;
}

.close {
  height: 50px;
  width: 50px;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .list,
  .icons-list {
    display: none;
  }

  .burger {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1px;
  }

  .logo {
    margin: 0;
  }

  nav {
    padding: 30px;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .list,
  .icons-list {
    display: none;
  }

  .burger {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1px;
  }

  .logo {
    margin: 0;
  }

  nav {
    padding: 30px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .list,
  .icons-list {
    display: none;
  }

  .burger {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1px;
  }
  .logo {
    margin: 0;
  }
  .list {
    gap: 30px;
  }
  .icons-list {
    gap: 15px;
  }
  nav {
    padding: 30px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .list,
  .icons-list {
    display: none;
  }

  .burger {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1px;
  }
  .logo {
    margin: 0;
  }
  .list {
    gap: 30px;
  }
  .icons-list {
    gap: 15px;
  }
  nav {
    padding: 30px;
  }
}
</style>